/**
 * Formats user-facing titles by stripping file extensions (e.g., .pdf, .docx)
 * and trailing duplicate indicators (e.g., " (1)", " (2)").
 */
export function formatDisplayTitle(rawTitle: string | null | undefined): string {
  if (!rawTitle) return "";
  let clean = rawTitle.trim();
  // Strip common file extension at end: .pdf, .docx, .pptx, etc.
  clean = clean.replace(/\.[a-zA-Z0-9]{2,5}$/i, "");
  // Strip duplicate trailing copy indicators like " (1)", " (2)"
  clean = clean.replace(/\s*\(\d+\)$/, "");
  return clean.trim() || rawTitle;
}
